import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';

type Color = {[key:string|symbol]:string};
type Emits = {(e: 'update:color', color: string): void};


export default /*@__PURE__*/_defineComponent({
  __name: 'color-selector',
  props: {
    color: {},
    state: {}
  },
  emits: ["update:color"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const emit = __emit;
const opened = ref<boolean>(false);

const colors = [
	{code: "#A70024", fontColor: "#FFF", name: "tomato",},
	{code: "#E67C73", fontColor: "#001", name: "flamingo",},
	{code: "#FFB878", fontColor: "#001", name: "tangerine",},
	{code: "#FBD75B", fontColor: "#001", name: "banana",},
	{code: "#33B679", fontColor: "#001", name: "sage",},
	{code: "#0B8043", fontColor: "#FFF", name: "basil",},
	{code: "#039BE5", fontColor: "#FFF", name: "peacock",},
	{code: "#3F51B5", fontColor: "#FFF", name: "blueberry",},
	{code: "#7986CB", fontColor: "#FFF", name: "lavender",},
	{code: "#616161", fontColor: "#FFF", name: "graphite",},
];

const close = () => {opened.value = false;};
const openClose  = () => {
	opened.value = props.state === "view" ? false : !opened.value;
};

const selectedColor = ref<Color>(
	colors.find(c => (c.code === props.color))
	|| {name: "peacock", code: "#039BE5", fontColor: "#FFF"}
);

watch(() => props.color, () => ([selectedColor.value] = colors.filter(c => c.code === props.color)));

function makeSelection(color: Color ) {
	openClose();
	selectedColor.value = color;
	if(color) emit('update:color', color.code);
}


const __returned__ = { props, emit, opened, colors, close, openClose, selectedColor, makeSelection, ref, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})